import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React__default, { useState } from 'react';
import { StyledAlert, ContentWrapper, MessageContainer, IconContainer, Message, ActionContainer } from './Alert.styles.js';
import { AlertType } from './Alert.types.js';
import { useDesignSystemThemeName, cleanProps } from '../utils.js';
import neutral from '../../themes/neutral/index.js';
import { ButtonType, ButtonSize, ButtonBlock, ButtonStatus } from '../Button/Button.types.js';
import { ClearOutline16, ErrorFilled16, InfoFilled16, ConfirmedFilled16 } from '../../icons/16/index.js';
import Button from '../Button/Button.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Alert = function Alert(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      closed = _useState2[0],
      setClosed = _useState2[1];

  var className = props.className;

  var renderIcon = function renderIcon(type) {
    switch (type) {
      case AlertType.ERROR:
        return /*#__PURE__*/React__default.createElement(ErrorFilled16, {
          color: neutral.colors.error900
        });

      case AlertType.SUCCESS:
        return /*#__PURE__*/React__default.createElement(ConfirmedFilled16, {
          color: neutral.colors.success900
        });

      case AlertType.INFO:
        return /*#__PURE__*/React__default.createElement(InfoFilled16, {
          color: neutral.colors.info900
        });

      case AlertType.WARNING:
        return /*#__PURE__*/React__default.createElement(ErrorFilled16, {
          color: neutral.colors.warning900
        });

      default:
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
    }
  };

  var statusHandler = function statusHandler(alertType) {
    switch (alertType) {
      case AlertType.ERROR:
        return ButtonStatus.ERROR;

      case AlertType.WARNING:
        return ButtonStatus.WARNING;

      case AlertType.INFO:
        return ButtonStatus.INFO;

      case AlertType.SUCCESS:
        return ButtonStatus.SUCCESS;

      default:
        return ButtonStatus.NONE;
    }
  };

  var type = props.type,
      message = props.message,
      banner = props.banner,
      closable = props.closable,
      closeLabel = props.closeLabel,
      actionButton = props.actionButton,
      actionHandler = props.actionHandler,
      actionText = props.actionText,
      onClose = props.onClose,
      customizeIcon = props.customizeIcon,
      style = props.style,
      isMobile = props.isMobile,
      dataTestId = props['data-test-id'];
  var themeName = useDesignSystemThemeName();

  var handleClose = function handleClose(e) {
    onClose === null || onClose === void 0 ? void 0 : onClose(e);
    setClosed(true);
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !closed && /*#__PURE__*/React__default.createElement(StyledAlert, _extends({}, cleanProps(props, ['action']), {
    className: "".concat(className || '', " ").concat(themeName, " sok-alert alert-type-").concat(type, " ").concat(isMobile && 'alert-mobile', "  ").concat(banner ? 'alert-banner' : '', " ").concat(closable ? 'alert-with-close' : ''),
    style: _objectSpread({}, style)
  }), /*#__PURE__*/React__default.createElement(ContentWrapper, null, /*#__PURE__*/React__default.createElement(MessageContainer, null, /*#__PURE__*/React__default.createElement(IconContainer, null, customizeIcon || renderIcon(type)), /*#__PURE__*/React__default.createElement(Message, null, message)), actionButton && /*#__PURE__*/React__default.createElement(ActionContainer, null, /*#__PURE__*/React__default.createElement(Button, {
    type: ButtonType.DEFAULT,
    status: statusHandler(type),
    size: ButtonSize.SMALL,
    blockOn: ButtonBlock.DESKTOP_DOWN,
    onClick: actionHandler,
    text: actionText,
    "data-test-id": "".concat(dataTestId, "-action")
  })), closable && /*#__PURE__*/React__default.createElement(Button, {
    className: "alert-close",
    type: ButtonType.TEXT,
    status: statusHandler(type),
    size: ButtonSize.SMALL,
    onClick: handleClose,
    icon: /*#__PURE__*/React__default.createElement(ClearOutline16, null),
    "aria-label": closeLabel,
    "data-test-id": "".concat(dataTestId, "-close")
  }))));
};

Alert.defaultProps = {
  'data-test-id': 'Alert'
};

export { Alert, Alert as default };
//# sourceMappingURL=Alert.js.map
